export const TERRITORY_PROMPTS_SIZE = 6;
